export const API_KEY = process.env.REACT_APP_APIKEY_GOOGLE_MAPS ?? ''